import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import React, { ReactNode } from 'react'

export default function CentsDialog({ children, opened, cancel }: { children: ReactNode, opened: boolean, cancel: () => void }) {

  return (
    <Dialog open={opened} onClose={cancel} as='div' className='relative z-50 focus:outline-none'>
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
      />
      <div className="fixed inset-0 w-screen overflow-y-auto p-4">
        <div className="flex min-h-full items-center justify-center">
          <DialogPanel transition className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in sm:my-8 sm:w-full sm:max-w-lg data-closed:sm:translate-y-0 data-closed:sm:scale-95">
            <div className='p-4'>
              {children}
            </div>
          </DialogPanel>
        </div>
      </div>

    </Dialog>
  )
}